
import store from '@js/store';

const CartService = {

	tasks: [],

	listeners: [],

	subscribe(taskName) {
		if (!this.taskRunning(taskName)) {
			this.pushTask(taskName, async () => {
				await store.dispatch('cart/getCart');
				return store.getters['cart/getCart'];
			});
		} else console.log('Service cache CART api call');

		return new Promise((resolve, reject) => {
			this.listeners.push({ taskName, resolve, reject });
		});
	},

	taskRunning(name) {
		return this.tasks.some(item => item.name === name);
	},

	async pushTask(name, method) {
		let data;
		let success;

		try {
			this.tasks.push({ name });
			data = await method();
			success = true;
		} catch(error) {
			success = false;
		}

		this.dismissListeners(name, data, success);

		this.tasks.splice(this.tasks.length - 1);
	},

	dismissListeners(taskName, data, success) {
		for (let i = this.listeners.length - 1; i >= 0; --i) {
			if (this.listeners[i].taskName === taskName) {
				success ? this.listeners[i].resolve(data) : this.listeners[i].reject(data);
				this.listeners.splice(i, 1);
			}
		}
	}

};

export default CartService;
